import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { savePublication } from '../../../../actions/publications'
import PublicationsSaveTemplate from '../../../templates/Admin/PublicationsSave'

class PublicationsSave extends Component {
  render () {
    return <PublicationsSaveTemplate {...this.props} />
  }
}

PublicationsSave.propTypes = {
  savePublication: PropTypes.func.isRequired
}

const mapDispatchToProps = dispatch => bindActionCreators({
  savePublication
}, dispatch)

export default connect(() => ({}), mapDispatchToProps)(PublicationsSave)



// WEBPACK FOOTER //
// ./src/components/pages/Admin/PublicationsSave/PublicationsSave.container.js